<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="main-row" *ngIf="isPaypal()">
  <div class="col-md-12">
    <fieldset>
      <legend class="row">
        <div class="col-md-6 m-auto">PayPal</div>
        <div class="col-md-6" *ngIf="!editable">
          <button
            class="btn btn-primary float-right"
            *ngIf="!hasPaypalAccountDetails() && isMerchantActive()"
            (click)="setEditable(true, false)"
          >
            <span>
              <fa-icon [icon]="faPlus"></fa-icon>
            </span>
            Add Accounts and IDs
          </button>

          <button
            class="btn btn-primary float-right"
            *ngIf="hasPaypalAccountDetails() && isMerchantActive()"
            (click)="setEditable(true, true)"
          >
            <span>
              <fa-icon [icon]="faEditPencil"></fa-icon>
            </span>
            Edit Accounts and IDs
          </button>
        </div>
      </legend>

      <div *ngIf="!editable">
        <div class="table-block">
          <div class="recordRow">
            <div class="recordLabel">Partner</div>
            <div id="paypalPartner" class="recordValue">
              {{ merchant.accountDetails.paypalAccountDetails.paypalPartner }}
            </div>
          </div>

          <div class="recordRow">
            <div class="recordLabel">Card Not Present Username</div>
            <div id="paypalCardNotPresentUsername" class="recordValue">
              {{
                merchant.accountDetails.paypalAccountDetails
                  .paypalCardNotPresentUsername
              }}
            </div>
          </div>
          <div class="recordRow" *ngIf="hasFinanceRole()">
            <div class="recordLabel">Card Not Present Password</div>
            <div id="paypalCardNotPresentPassword" class="recordValue">
              {{
                merchant.accountDetails.paypalAccountDetails
                  .paypalCardNotPresentPassword
              }}
            </div>
          </div>

          <div class="recordRow">
            <div class="recordLabel">Card Present Username</div>
            <div id="paypalCardPresentUsername" class="recordValue">
              {{
                merchant.accountDetails.paypalAccountDetails
                  .paypalCardPresentUsername
              }}
            </div>
          </div>
          <div class="recordRow" *ngIf="hasFinanceRole()">
            <div class="recordLabel">Card Present Password</div>
            <div id="paypalCardPresentPassword" class="recordValue">
              {{
                merchant.accountDetails.paypalAccountDetails
                  .paypalCardPresentPassword
              }}
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3" *ngIf="editable">
        <form
          name="merchantAddressFormControl"
          class="form-horizontal"
          novalidate
          [formGroup]="paypalAccountDetailsFormGroup"
          (submit)="setPayPalAccountDetails()"
        >
          <app-pay-pal-detail-edit
            [payPalGroup]="paypalAccountDetailsFormGroup"
            [editMode]="updateMode"
          >
          </app-pay-pal-detail-edit>

          <div class="row mt-2">
            <fieldset class="col-md-12">
              <div class="float-right">
                <button
                  type="button"
                  class="btn btn-light mr-1"
                  (click)="setEditable(false, false)"
                >
                  <fa-icon [icon]="faTrash"></fa-icon>
                  Cancel Changes
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  [disabled]="actionInProgress"
                >
                  <span
                    *ngIf="actionInProgress"
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <fa-icon
                    *ngIf="!actionInProgress"
                    [icon]="faEditPencil"
                  ></fa-icon>
                  Submit
                </button>
              </div>
            </fieldset>
          </div>
        </form>
      </div>
    </fieldset>
  </div>
</div>
